import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { LwFormInput } from 'redesign';
import { EmployeeFormData } from '../employee-create/employee-create';

export const EmployeeForm = () => {
  const { control } = useFormContext<EmployeeFormData>();

  return (
    <form aria-label="Employee form">
      <Grid container item xs={9} spacing={2}>
        <Grid item xs={6}>
          <LwFormInput
            name="email"
            control={control}
            label="Email"
            rules={{ required: 'Voer een email in' }}
          />
          <LwFormInput
            name="firstName"
            control={control}
            label="Voornaam"
            rules={{ required: 'Voer een voornaam in' }}
          />
          <LwFormInput name="infix" control={control} label="Tussenvoegsel" />
          <LwFormInput
            name="lastName"
            control={control}
            label="Achternaam"
            rules={{ required: 'Voer een achternaam in' }}
          />
        </Grid>
      </Grid>
    </form>
  );
};
